import React, { useState } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { FormComboBox } from "components/Matters";
import { Button } from "@progress/kendo-react-buttons";
import styles from "./Matter.module.scss";
import { CrossIcon } from "components/tabs/TabTitle";
import { useActiveFeeEarner } from "services/userService";

export const MatterPermissions = ({
  matterId,
  accessibleUsers = [],
  setAccessibleUsers,
  isView,
}) => {
  const { data: feeEarners } = useActiveFeeEarner();
  const [comboBoxState, setComboBoxState] = useState({
    accessibleUser: "",
  });

  const addedRefs = new Set(
    accessibleUsers
      .filter((u) => u.active)
      .map((u) => u.feeEarnerRef || u.userRef)
  );
  const availableFeeEarners = feeEarners.filter(
    (fe) => !addedRefs.has(fe.userRef)
  );

  const handleAccesibleUsers = async (feeEarner, type) => {
    try {
      if (type === "add") {
        setAccessibleUsers((prevItem) => [
          ...prevItem,
          {
            feeEarnerRef: feeEarner?.userRef,
            displayName: feeEarner?.displayname,
            active: true,
          },
        ]);
        setComboBoxState({ ...comboBoxState, accessibleUser: "" });
      } else {
        const updatedUsers = accessibleUsers.map((user) => {
          if (
            user?.feeEarnerRef === feeEarner.feeEarnerRef ||
            user?.userRef === feeEarner.feeEarnerRef
          ) {
            user.active = false;
          }
          return user;
        });
        setAccessibleUsers(updatedUsers);
      }
    } catch (error) {}
  };

  const FeeEarnerCell = (props) => {
    return (
      <td className="d-flex justify-content-between">
        <span>{props.dataItem?.displayName}</span>
        {!isView && (
          <CrossIcon
            onClick={() => {
              handleAccesibleUsers(props.dataItem, "remove");
            }}
          />
        )}
      </td>
    );
  };

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between"
        style={{ height: "50px" }}
      >
        <div className={`${styles["section-title"]}`}>Permissions</div>
      </div>
      <hr className="mt-0" />
      <div>
        {!isView && (
          <div className="d-flex gap-3 align-items-end">
            <FormComboBox
              wf={true}
              isStyled={true}
              width={"260px"}
              onChangeComboBox={(e) => {
                setComboBoxState({
                  ...comboBoxState,
                  accessibleUser: e.value,
                });
              }}
              data={availableFeeEarners}
              textField="display"
              state={comboBoxState}
              name={"accessibleUser"}
              placeholder={"Set Accessible User"}
              label={"User"}
            />
            <Button
              className="button-small mb-1 bgBtnSecondary"
              onClick={() => {
                handleAccesibleUsers(comboBoxState["accessibleUser"], "add");
              }}
              type="button"
              disabled={!comboBoxState["accessibleUser"]}
            >
              {" "}
              Add User{" "}
            </Button>
          </div>
        )}
        <Grid
          data={accessibleUsers.filter((user) => user.active)}
          className="mt-2 mb-1"
          style={{
            minHeight: "150px",
          }}
        >
          <GridColumn
            field="displayName"
            title="Users"
            headerClassName="ps-3"
            cell={FeeEarnerCell}
          />
        </Grid>
      </div>
    </>
  );
};
